import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { Component, inject, OnInit, signal } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';
import { TopStatsRow } from './atoms/top-stats-row/top-stats-row';
import { LatestBriefs } from './atoms/latest-briefs/latest-briefs';
import { UnreadMessages } from './atoms/unread-messages/unread-messages';
import { RecentActivity } from './atoms/recent-activity/recent-activity';
import { VideosToReview } from './atoms/videos-to-review/videos-to-review';
import { InterestedCreators } from './atoms/interested-creators/interested-creators';
import { RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { GaService } from '@/app/services/ga/ga';
import { StorageService } from '@/app/services/storage/storage.service';
import { VersionService } from '@/app/services/version/version.service';
import { HasRoleDirectiveDirective } from '@/app/common/directives/has-role/has-role-directive.directive';

const dashboardFirstVisitStorageKey = (userId: string) =>
  `dashboard_first_visit_tracked_${userId}`;

@Component({
  selector: 'app-dashboard-v2',
  imports: [AsyncPipe, RouterLink, TopStatsRow, LatestBriefs, UnreadMessages, RecentActivity, VideosToReview, InterestedCreators, DatePipe, HasRoleDirectiveDirective],
  templateUrl: './dashboard-v2.html',
  styleUrl: './dashboard-v2.scss',
})
export class DashboardV2Component implements OnInit {

  lastVisit = signal<Date | null>(null);
  readonly appVersion = inject(VersionService).getAppVersion();

  /** Services */
  public currentUserService = inject(CurrentUserService);
  private gaService = inject(GaService);
  private storageService = inject(StorageService);
  /** Services - END */

  async ngOnInit(): Promise<void> {
    const user = await firstValueFrom(this.currentUserService.getShoutUser());
    await this.trackPageView(user);
    this.lastVisit.set(user?.latest_user_visit ?? null);
  }

  async trackPageView(
    user: { id?: string; firebaseUid?: string; latest_user_visit?: Date } | null | undefined,
  ): Promise<void> {
    const userId = user?.id ?? user?.firebaseUid;
    const storageKey = userId ? dashboardFirstVisitStorageKey(userId) : null;

    const alreadyTracked =
      (storageKey && this.storageService.getAndParse<boolean>(storageKey) === true) ||
      !!user?.latest_user_visit;

    if (!alreadyTracked) {
      this.gaService.trackOnboardingEvent('dashboard_first_visit');
      if (storageKey) {
        this.storageService.setAndString(storageKey, true);
      }
      return;
    }

    this.gaService.trackOnboardingEvent('dashboard_visit');
  }
}
